import { Box, Button, Dialog, Icon, IconButton, Stack, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useWorkTaskOrderModuleParameters, useCostEstimationModuleParameters } from "@tm/context-distribution"
import { useHistory, useParams, useRouteMatch } from "react-router"
import { useCallback, useState } from "react"
import { openStreamPdf, renderRoute } from "@tm/utils"
import { useCostEstimationDetails } from "../../../../../../business/hooks/useCostEstimationDetails"
import { useVoucherButtonsActions } from "../../../../../../business/hooks/useVoucherButtonsActions"
import { VoucherRouteParams } from "../../../../../../../../business"
import { useDeleteCostEstimation } from "../../../../../../../../data/hooks/useVoucherList"
import * as Data from "../../../../../../../../data"

export function CostEstimationActionButtons() {
    const { translateText, languageId } = useLocalization()
    const params = useParams<VoucherRouteParams>()
    const history = useHistory()
    const { path } = useRouteMatch()

    const voucherId = params.id && decodeURIComponent(params.id)
    const { hasWorkTaskOrder } = useWorkTaskOrderModuleParameters()
    const { hasCostEstimation } = useCostEstimationModuleParameters()
    const { costEstimationDetails, costEstimationDetailsLoading } = useCostEstimationDetails(voucherId)
    const { costEstimationButtonAction } = useVoucherButtonsActions()
    const { deleteCostEstimations } = useDeleteCostEstimation()
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false)
    const url = renderRoute(path, { ...params, id: undefined })
    const buttonDisabled = !costEstimationDetails?.costEstimation?.parts?.length || costEstimationDetailsLoading

    function handleOrderParts(redirectToCostEstimation: boolean) {
        costEstimationButtonAction(costEstimationDetails, redirectToCostEstimation)
    }
    const handleDeleteCostEstimation = useCallback(() => {
        if (!voucherId) {
            return
        }

        deleteCostEstimations([voucherId])
        setShowDeleteDialog(false)
        history.push(url)
    }, [deleteCostEstimations, history, url, voucherId])

    function handlePrintButtonClick() {
        if (voucherId) {
            Data.showCostEstimationPdf(voucherId).then((costEstimationPdf) => {
                if (costEstimationPdf) {
                    openStreamPdf(costEstimationPdf, translateText)
                }
            })
        }
    }

    return (
        <Stack direction="row" spacing={0.5}>
            <IconButton disabled={!voucherId} onClick={handlePrintButtonClick} title={translateText(49)} size="large" variant="contained">
                <Icon name="print" />
            </IconButton>
            <IconButton onClick={() => setShowDeleteDialog(true)} title={translateText(69)} size="large" variant="contained">
                <Icon name="delete" />
            </IconButton>
            {showDeleteDialog && (
                <Dialog open skin="warning" position="top" fullWidth>
                    <Stack direction="row" spacing={2}>
                        <Typography>{translateText(1752)}</Typography>
                        <Box textAlign="center" display="flex" flexWrap="nowrap" height={45}>
                            <Button variant="contained" onClick={() => setShowDeleteDialog(false)}>
                                {translateText(584)}
                            </Button>
                            <Button variant="contained" sx={{ marginLeft: 1 }} color="success" onClick={handleDeleteCostEstimation}>
                                {translateText(585)}
                            </Button>
                        </Box>
                    </Stack>
                </Dialog>
            )}
            {hasCostEstimation && (
                <Button
                    startIcon={<Icon name={languageId === "1" ? "voucher-kva-summary" : "voucher-kva-international-summary"} />}
                    disabled={buttonDisabled}
                    onClick={() => handleOrderParts(true)}
                >
                    {translateText(3041)}
                </Button>
            )}
            {hasWorkTaskOrder && (
                <Button
                    color="highlight"
                    startIcon={<Icon name="cart" />}
                    disabled={buttonDisabled}
                    onClick={() => handleOrderParts(false)}
                    title={translateText(937)}
                >
                    {translateText(50)}
                </Button>
            )}
        </Stack>
    )
}
